<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-indent:0em">I wish to dedicate this book to Dr. Ferdinando Alfonsi. I met him and his wife, Dr. Sandra Alfonsi, when she injured her arm. She called my cleaning company for help in her house and told us that the work was temporary, just until her arm was healed. Due to a shortage of workers, my wife and I did the work. After a few years, due to circumstances at home, Sandra required our services again. But because my wife had passed, Sandra asked Ferdinando if it would be alright for me to do the work alone. If Ferdinando had said no, this book might have never been written. Let me explain why. With each cleaning visit, I grew closer to Ferdinando and Sandra. At times, I would read things aloud and Ferdinando would listen and compliment my work. I showed Sandra the misspelled scribble. But Sandra saw more.</p>
<br/><p style="text-indent:0em">Sandra, who, out of respect for Ferdinando, would not do something without discussing it first, asked Ferdinando if she could work with me and teach me. For me, his saying “yes” was the greatest gift anyone could bestow upon me. Without him, Sandra would not teach me. Ferdinando’s “yes” made the difference in my life.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?278ccc7a